import LoginForm from "../../components/auth/forms/LoginForm";

const LoginPage = () => {

  return (
    <LoginForm />
  );
};

export default LoginPage;
